export const flow = {
  formId: "save-flow",
  formField: {
    flowId: {
      name: "flowId",
      label: "flow ID",
      type: "id"
    },
    flowName: {
      name: "flowName",
      label: "flow name",
      type: "text",
      placeholder: "eg. New flow",
      errorMsg: "Flow Name is required."
    },
    description: {
      name: "description",
      label: "description",
      type: "text",
      placeholder: "eg. This is an information about the flow",
      errorMsg: "Description is required."
    },
    integration: {
      name: "integration",
      label: "integration",
      type: "text",
      placeholder: "eg. Chat Bot Flow",
      errorMsg: "Integration is required."
    },
    executionTimeoutDuration: {
      name: "executionTimeoutDuration",
      label: "timeout after seconds",
      type: "number",
      errorMsg: "Execution timeout duration is required."
    },

    retryOnFail: {
      name: "retryOnFail",
      label: "retry on fail",
      type: "boolean"
    },
    maximumTries: {
      name: "maximumTries",
      label: "maximum tries",
      type: "number"
    },
    waitBetweenTries: {
      name: "waitBetweenTries",
      label: "wait between tries",
      type: "number"
    },
    onError: {
      name: "onError",
      label: "on error",
      type: "select"
    },
    notes: {
      name: "notes",
      label: "notes",
      type: "text"
    },
    displayExecutionLogs: {
      name: "displayExecutionLogs",
      label: "display execution logs",
      type: "boolean"
    },
    returnValue: {
      name: "returnValue",
      label: "return value",
      type: "selectWithDetails",
      options: [
        {
          label: "When Last Node Finishes",
          subLabel: "Returns data of the last-executed node",
          value: "last_node_finishes"
        },
        {
          label: "Inline",
          subLabel: "Code or Respond nodes define when to send response",
          value: "inline_code"
        }
      ]
    }
  }
};
